import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable,throwError } from "rxjs";
import { combineAll,catchError } from "rxjs/operators";
import { appConstants } from "../constants/appConstants";
import { AuthenticationService } from "../services/authentication.service";
import { NotificationService } from "../services/notification.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private _authService: AuthenticationService,
    private notifier: NotificationService,
  ) {
    
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let currentUser = localStorage.getItem(appConstants.TOKEN_NAME);
    if (currentUser) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ` + currentUser,
        },
      });
    }
    return next.handle(request).pipe(
      // retry(1),
      catchError((error: HttpErrorResponse) => {
        // this.spinner.hide();
        if (error.status === 401 ) {
          this.notifier.showError(
            'Error',
            'Error Code: ' + error.status + ' Message: ' + error.message
          );
          this._authService.logOut();
        } else if (error.status === 404) {
          this.notifier.showError('Error', 'Nothing Found');
        } else if (error.status === 403) {
          this.notifier.showError('Error', 'Access Forbidden');
        } else {
          this.notifier.showError(
            'Error',
            'Error Code: ' + error.status + ' Message: ' + error.error.message
          );
        }
        return throwError(error);
      })
    );
  }
}
